import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from "../../components/context/context"

import logo from "../../assets/imgs/mssatlogo.png"
import useWindowSize from '../../components/windowSize/useWindowSize';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const { increaseFontSize, decreaseFontSize, defaultFontSize, enableCharacterSpacing } = useTheme();
    const screenSize = useWindowSize();
    const scrollToMainContent = () => {
        const mainContentElement = document.getElementById("main-content");

        if (mainContentElement) {
            const offset = mainContentElement.offsetTop + 80;

            window.scrollTo({
                top: offset,
                behavior: "smooth",
            });
        }
    }
    const style = {
        navContainer: {
            // padding:screenSize < 780 ? "0 " : "10px 20px" ,

            fontSize: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        top: {
            width: screenSize < 780 ? "100%" : "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        topLeft: {
            display: "flex",
            alignItems: "center",
            margin: "10px 20px",
        },
        logoContainer: {
            height: "50px",
            marginRight: "10px",
            marginBottom: "5px",
        },
        logoImage: {
            height: "100%",
            width: "auto",
            // mixBlendMode: "color-burn",
        },
        topRight: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            margin: "10px 20px",

        },
        fontControl: {
            cursor: "pointer",
            // padding: "5px 10px", 
        },
        bottomNav: {
            width: screenSize < 780 ? "100%" : "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            backgroundColor: "teal",
            color: "white",
        },
    };

    return (
        <div className="Navbar_container" style={style.navContainer}>
            <div className="Top_nav-container" style={style.top}>
                <div className="Top_nav-left" style={style.topLeft}>
                    <div style={style.logoContainer}>
                        <Link to="/" >
                            <img src={logo} alt="mssat-logo" style={style.logoImage} />

                        </Link>
                    </div>
                    <div>
                        {
                            screenSize >= 780 ?
                                <Typography variant="h5" style={{ textShadow: "2px 1px 2px gray", fontWeight: 500, fontFamily: 'Merriweather, serif' }}>MEGHALAYA SOCIETY FOR SOCIAL AUDIT & TRANSPARENCY</Typography> : <Typography variant="h5" style={{ textShadow: "2px 1px 2px grey", fontWeight: "bold", fontFamily: 'Merriweather, serif' }}>MSSAT</Typography>
                        }
                    </div>
                </div>
                <div className="Top_nav-right" style={style.topRight}>
                    <Tooltip title="Increase character spacing"><Typography variant="h7" onClick={enableCharacterSpacing} style={{
                        cursor: "pointer"
                    }}>Enable Character Spacing</Typography></Tooltip>
                    <div style={{ background: "gray", width: "1px", height: "1.2rem", margin: "0 0px" }}></div>
                    <Tooltip title="Scroll down to main content"><Typography variant="h7" onClick={scrollToMainContent} style={{
                        cursor: "pointer"
                    }}>Skip to main content</Typography></Tooltip>
                    <div style={{ background: "gray", width: "1px", height: "1.2rem", margin: "0 0px" }}></div>
                    <div>
                        <Tooltip title="Decrease Font Size">
                            <Typography variant="h7" >
                                <button onClick={decreaseFontSize} style={style.fontControl}>A-</button>
                            </Typography>
                        </Tooltip>
                        <Tooltip title="Reset Font Size">
                            <Typography variant="h7" >
                                <button onClick={defaultFontSize} style={style.fontControl}>A</button>
                            </Typography>
                        </Tooltip>
                        <Tooltip title="Increase Font Size">
                            <Typography variant="h7" >
                                <button onClick={increaseFontSize} style={style.fontControl}>A+</button>
                            </Typography>
                        </Tooltip>
                    </div>
                </div>
            </div>
            {/* <div className="Bottom_nav-container" style={style.bottomNav}>
                <TopNav />
            </div> */}

        </div>
    );
}
